"use client";
import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { memo as n, forwardRef as e } from "react";
import { useSvgIcon as s } from "../useSvgIcon.js";
const m = n(
  e((C, l) => {
    const { monochrome: o, ...t } = C, c = s({
      ...t,
      ref: l
    });
    return /* @__PURE__ */ i(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c(),
        children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M30.0002 16.3158C30.0014 15.3614 29.9191 14.4087 29.7542 13.4688H16.2842V18.8608H23.9992C23.838 19.7266 23.5018 20.5505 23.0113 21.2819C22.5207 22.0134 21.8861 22.6369 21.1462 23.1147V26.6147H25.7462C27.1446 25.2975 28.2471 23.6982 28.9805 21.9226C29.7139 20.1471 30.0615 18.2359 30.0002 16.3158Z",
              fill: o ? "var(--icon-color)" : "#4285F4"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M16.2825 29.9958C19.7506 30.0967 23.1299 28.8906 25.7505 26.6168L21.1505 23.1168C19.6976 24.0334 18.0058 24.499 16.2885 24.4548C14.5172 24.4439 12.7932 23.8816 11.3561 22.8459C9.91901 21.8103 8.84021 20.3527 8.26951 18.6758H3.52051V22.2828C4.73391 24.6168 6.56681 26.5713 8.81811 27.9319C11.0694 29.2926 13.652 30.0066 16.2825 29.9958Z",
              fill: o ? "var(--icon-color)" : "#34A853"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M8.2639 18.6759C7.666 16.9396 7.666 15.0533 8.2639 13.3169V9.71094H3.5209C2.5214 11.6556 2 13.8105 2 15.9969C2 18.1834 2.5214 20.3383 3.5209 22.2829L8.2639 18.6759Z",
              fill: o ? "var(--icon-color)" : "#FBBC04"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M16.2825 7.53926C18.3118 7.50376 20.2758 8.25647 21.7615 9.63927L25.8385 5.63927C23.2322 3.25467 19.8147 1.95359 16.2825 2.00127C13.6524 1.99001 11.0701 2.70346 8.81881 4.06336C6.56761 5.42326 4.73441 7.37706 3.52051 9.71026L8.26351 13.3173C8.83441 11.6405 9.91331 10.1832 11.3503 9.14767C12.7874 8.11226 14.5113 7.55006 16.2825 7.53926Z",
              fill: o ? "var(--icon-color)" : "#EA4335"
            }
          )
        ]
      }
    );
  })
);
m.displayName = "IconGoogle";
export {
  m as IconGoogle
};
